import Vue from 'vue'
import VueRouter from 'vue-router'
import Home from '../views/Home.vue'

Vue.use(VueRouter)

const routes = [
	{
		path: '/',
		name: 'Login',
		component: function () 
		{
			return import('../views/Login.vue')
		}
	},
	{
		path: '/home',
		name: 'Home',
		component: function () 
		{
			return import('../views/Home.vue')
		}
	},
	{
		path: '/about',
		name: 'About',
		component: function () 
		{
			return import('../views/About.vue')
		}
	},
]

const router = new VueRouter({
  base: process.env.BASE_URL,
  routes
})
// 导航守卫
router.beforeEach((to,from,next)=>
{
	var user=localStorage.getItem('userName')
	if(to.path=='/' || user)
	{
		next()
	}
	else
	{
		alert('请先登录')
		next('/')
	}
})

export default router
